import React from "react";
import { useNavigate } from "react-router-dom";
import wll from "../../Assets/blueWaveLeft.png";
import wrr from "../../Assets/BlueWaveRight.png";
import wnf from "../../Assets/Washandfold.png";
import wni from "../../Assets/Washandiron.png";
import dc from "../../Assets/Drycleaning.png";
import bsc from "../../Assets/Bedsheetcare.png";
import sgc from "../../Assets/SpecialGramentsCare.png";
import sc from "../../Assets/ShoesCare.png";
import cc from "../../Assets/curtain.png";
import bc from "../../Assets/school-bag.png";
import si from "../../Assets/steam-iron.png";
import st from "../../Assets/toys.png";

export default function OurService() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center relative -top-[140px] md:-top-[50px] ">
      <div className="md:flex md:justify-around md:items-center">
        <div>
          <img src={wll} alt="blueWaveLeft" className="hidden md:flex" />
        </div>
        <p className="text-[36px] md:text-[64px] text-center font-[700] text-[#0fbfe6] pb-2 md:py-2">
          Our Services
        </p>
        <div>
          <img src={wrr} alt="BlueWaveRight" className="hidden md:flex" />
        </div>
      </div>
      <div>
        <p className="text-black">Comprehensive Laundry Solutions</p>
      </div>
      <div className="flex flex-col justify-center items-center gap-6 md:gap-[100px] pt-8">
        <div className="grid grid-cols-3 gap-6 md:gap-[100px]">
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={wnf}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Wash & Fold
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={wni}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Wash & Iron
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={dc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Dry Cleaning
            </p>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-6 md:gap-4">
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={bsc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Bedsheet & Blanket Care
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={sgc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Special Garment Care
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={sc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Shoe Spa & Cleaning
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={cc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Curtain & Upholstery Cleaning
            </p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-6 md:gap-[100px]">
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={st}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              Soft toy Care
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={bc}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">Bags Care</p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="h-[50px] md:h-[120px] w-[50px] md:w-[120px]"
              src={si}
              alt="Service "
            />
            <p className="text-center text-[12px] md:text-[20px]">
              wash & steam iron
            </p>
          </div>
        </div>
      </div>
      <div className="flex gap-12 z-50">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "0.5em 1em",
            backgroundColor: "#0FBFE6",
            borderRadius: "25px",
            marginTop: "2em",
            cursor: "pointer",
            width: "120px",
            color: "#fff",
          }}
          onClick={() => navigate("Price")}
          variant="gradient"
        >
          Pricing Plan
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "0.5em 1em",
            backgroundColor: "#0FBFE6",
            borderRadius: "25px",
            marginTop: "2em",
            cursor: "pointer",
            width: "120px",
            color: "#fff",
          }}
          onClick={() => {
            navigate("SchedulePickUp");
          }}
        >
          Book Now
        </div>
      </div>
    </div>
  );
}
